class Token {

    isValid(token){
        const payload = this.payload(token)
        let url = process.env.NODE_ENV == 'production' ? process.env.VUE_APP_API_URL_PROD : process.env.VUE_APP_API_URL_LOCAL
        if(payload){
            return payload.iss == `${url}/api/auth/login`
            || `${url}/api/auth/signup` ? true : false
        }
        return false
    }

    payload(token){

        if(token){
            const payload = token.split('.')[1]
            return this.decode(payload)
        }else{
            return false
        }

    }

    decode(payload){
        if(this.isBase64(payload)){
            return JSON.parse(atob(payload))
        } else {
            return false
        }

    }

    isBase64(str) {
        //against changing the token manually in the browser
        try{
            return btoa(atob(str)).replace(/=/g,"") == str
        }catch(err){
            return false
        }
    }
}

export default Token = new Token()
